// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__oslkF","content":"style_content__oBcNr","button":"style_button__YHew3","title":"style_title__xHl53","info":"style_info__HYC92"};